import { render, staticRenderFns } from "./feature1.vue?vue&type=template&id=2d6fb80f&scoped=true&"
import script from "./feature1.vue?vue&type=script&lang=js&"
export * from "./feature1.vue?vue&type=script&lang=js&"
import style0 from "./feature1.vue?vue&type=style&index=0&id=2d6fb80f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6fb80f",
  null
  
)

export default component.exports